import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";

import Hero from "./Hero";
import Services from "./Services";
import Features from "../components/sections/Features";
import Testimonials from "../components/sections/Testimonials";
import Team from "./Team";
import Contact from "./Contact";

import MovingTruck from "../components/ui/MovingTruck";
import WhatsAppButton from "../components/ui/WhatsAppButton";

const Home = () => {
  return (
    <>
      <Navbar />

      {/* HERO (id already inside Hero) */}
      <Hero />

      {/* DIVIDER */}
      <MovingTruck />

      {/* SERVICES */}
      <Services />

      {/* FEATURES */}
      <Features />

      {/* TEAM */}
      <Team />

      {/* TESTIMONIALS */}
      <Testimonials />

      {/* CONTACT */}
      <Contact />

      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default Home;
